import { Component, OnInit, Input } from "@angular/core";
import { ServerService } from "../../../../shared/services/server.service";
import { environment } from "../../../../../environments/environment";
import { EventService } from "../../../../shared/services/event.service";
import * as moment from "moment";
import { UserInfo } from "../../../header/header.component";

export interface MonthFiles {
  monthId?: number;
  monthName: string;
  allBuildingImagePerMonth?: ImageFile[];
}
@Component({
  selector: "app-object-album",
  templateUrl: "./object-album.component.html",
  styleUrls: ["./object-album.component.scss"]
})
export class ObjectAlbumComponent implements OnInit {
  api = environment.apiUrl;

  @Input() livingComplexID: number;
  @Input() buildingId: number;

  loader: boolean = false;
  selectBtn: boolean = false;
  deleteBtn: boolean = false;
  checkBox: boolean = false;
  openImg: boolean = false;
  openImgId: number = 0;
  onePhotoUri: string = "";
  selectedImg: ImageFile = null;
  allBuildingMonth: MonthFiles[] = [];
  allBuildingImage: ImageFile[] = [];
  allBuildingMonth1: MonthFiles[] = [];
  comment: CommentPhoto;
  commentsPhoto: CommentsPhoto[] = [];
  constructor(
    private serverService: ServerService,
    private eventService: EventService
  ) {}

  ngOnInit() {
    this.uploadData();
    // this.getComments();
    this.allBuildingMonth1 = [
      { monthId: 0, monthName: "Январь", allBuildingImagePerMonth: [] },
      { monthId: 1, monthName: "Февраль", allBuildingImagePerMonth: [] },
      { monthId: 2, monthName: "Март", allBuildingImagePerMonth: [] },
      { monthId: 3, monthName: "Апрель", allBuildingImagePerMonth: [] },
      { monthId: 4, monthName: "Май", allBuildingImagePerMonth: [] },
      { monthId: 5, monthName: "Июнь", allBuildingImagePerMonth: [] },
      { monthId: 6, monthName: "Июль", allBuildingImagePerMonth: [] },
      { monthId: 7, monthName: "Август", allBuildingImagePerMonth: [] },
      { monthId: 8, monthName: "Сентябрь", allBuildingImagePerMonth: [] },
      { monthId: 9, monthName: "Октябрь", allBuildingImagePerMonth: [] },
      { monthId: 10, monthName: "Ноябрь", allBuildingImagePerMonth: [] },
      { monthId: 11, monthName: "Декабрь", allBuildingImagePerMonth: [] }
    ];
    this.comment = {
      DBFileID: 0,
      Comment: "",
      CommentID: null
    };
  }

  uploadData() {
    this.serverService
      .getAllBuildingsPhotoById(this.buildingId, null)
      .then(res => {
        this.allBuildingImage = this.updateData(res);
        this.allBuildingMonth1.map(r => {
          r.allBuildingImagePerMonth = this.allBuildingImage.filter(
            r2 => r.monthId === r2.updatedOn
          );
        });
        this.allBuildingMonth = this.allBuildingMonth1.filter(val => {
          return val.allBuildingImagePerMonth.length !== 0;
        });

        for (let i = 0; i < this.allBuildingMonth.length; i++) {
          if (this.allBuildingMonth[i].allBuildingImagePerMonth.length < 5) {
            let a =
              4 - this.allBuildingMonth[i].allBuildingImagePerMonth.length;
            for (let j = 0; j < a; j++) {
              this.allBuildingMonth[i].allBuildingImagePerMonth.push({
                fileId: 0,
                src: "",
                srcFalse: "",
                selected: false,
                fileTypeID: 0,
                updatedOn: ""
              });
            }
          }
        }
      });
  }

  buildingImagesPerMonth: ImageFile[] = [];
  openMonthModal: boolean = false;
  openAlbum(allBuildingImagePerMonth: ImageFile[] = []) {
    this.openMonthModal = true;
    this.buildingImagesPerMonth = allBuildingImagePerMonth.filter(r => {
      return r.fileId != 0;
    });
  }
  updateData(rows) {
    let res: ImageFile[] = rows.map(r => {
      var d = new Date(r.updatedOn);
      var n = d.getMonth();
      return {
        fileId: r.id,
        src:
          this.api +
          "BuildingFiles/DownloadFile?fileID=" +
          r.id +
          "&isThumb=" +
          true,
        srcFalse:
          this.api +
          "BuildingFiles/DownloadFile?fileID=" +
          r.id +
          "&isThumb=" +
          false,
        selected: false,
        fileTypeID: r.fileTypeID,
        updatedOn: n,
        updateDate: moment(d).format("YYYY-MM-DD")
      };
    });
    return res;
  }

  selectImage(img: ImageFile) {
    img.selected = !img.selected;
  }

  selectedImages() {
    this.checkBox = !this.checkBox;
    this.allBuildingImage.map(r => {
      r.selected = false;
    });
    this.deleteBtn = !this.deleteBtn;
  }

  deleteImages() {
    let flag = this.allBuildingImage.findIndex(f => f.selected === true);
    if (flag == -1) {
      alert("Пожалуйста, выберите фото!");
    } else {
      this.loader = true;
      for (let i = 0; i < this.allBuildingImage.length; i++) {
        if (this.allBuildingImage[i].selected === true) {
          this.serverService
            .deleteBuildingPhotoById(this.allBuildingImage[i].fileId)
            .then(res => {
              if (res === "Удалено") {
                this.loader = false;
                this.checkBox = false;
                this.uploadData();
                this.deleteBtn = false;
              }
            });
        }
      }
    }
  }

  handleFileInputForBuildings(event: any) {
    let files = event;
    for (let i = 0; i < files.length; i++) {
      let fileType = files[i].type.substr(files[i].type.indexOf("/") + 1);
      let fileTypeID = 0;
      let imgTypes = ['png','jpg','jpeg','jfif','gif', 'tiff', 'psd', 'bmp', 'raw', 'svg', 'pct', 'tif' ];
      let videoTypes = ['quicktime','avi','mp4','mov','3gp', 'mkv', 'wmv', 'mpeg', 'mpg', 'vob', 'flv'];
      let isImg = imgTypes.findIndex(f => f.toLowerCase() == fileType.toLowerCase());
      let isVideo = videoTypes.findIndex(f => f.toLowerCase() == fileType.toLowerCase());
      if (isImg != -1) {
        fileTypeID = 1;
      } else if(isVideo != -1) {
        fileTypeID = 2;
      }
      this.loader = true;
      this.serverService
        .insertBuildingPhoto(
          this.buildingId,
          files[i],
          null,
          fileTypeID,
          fileType,
          ""
        )
        .then(res => {
          if (res) {
            this.eventService.updateMainThumbnail.emit(res);
            this.uploadData();
            this.loader = false;
          }
        });
    }
  }

  openImage(img: ImageFile) {
    this.selectedImg = img;
    this.openImg = true;
    this.openImgId = img.fileId;
    this.onePhotoUri =
      this.api + "BuildingFiles/DownloadFile?fileID=" + img.fileId;
    this.getComments(this.openImgId);
  }
  getComments(openImgId) {
    this.serverService.getPhotoComments(openImgId).then(r => {
      this.commentsPhoto = r;
    });
  }

  clickedSlider(val: string, selectedImg: ImageFile) {
    let lengthArr = this.allBuildingImage.length - 1;
    let index = this.allBuildingImage.findIndex(
      r => r.fileId === selectedImg.fileId
    );
    let sel: ImageFile;
    if (val === "right") {
      if (index === lengthArr) {
        sel = this.allBuildingImage[0];
      } else {
        sel = this.allBuildingImage[index + 1];
      }
    }
    if (val === "left") {
      if (index === 0) {
        sel = this.allBuildingImage[lengthArr];
      } else {
        sel = this.allBuildingImage[index - 1];
      }
    }
    this.openImage(sel);
  }

  selectedPhotoIdForMainPhoto: number;
  getCount(): boolean {
    let count = 0;
    this.allBuildingImage.map(r => {
      if (r.selected) count++;
    });
    if (count == 1) {
      this.selectedPhotoIdForMainPhoto = this.allBuildingImage.find(
        f => f.selected === true
      ).fileId;
      return true;
    }
    return false;
  }

  updateMainPhoto() {
    this.serverService
      .updLivingComplexPhoto(
        this.selectedPhotoIdForMainPhoto,
        this.livingComplexID
      )
      .then(res => {
        this.eventService.updateMainThumbnail.emit(
          this.selectedPhotoIdForMainPhoto
        );
      });
  }
  
  public user: UserInfo = null;
  sendComment(fileId: number) {
    this.comment.DBFileID = fileId;
    this.serverService.setPhotoComment(this.comment).then(r => {
      var now = new Date();
      let user = localStorage.getItem('user');
    if (user) {
      this.user = JSON.parse(user);
    }
      this.commentsPhoto.push({
        updatedOn:  moment(now).format("YYYY-MM-DD HH:mm:ss"),
        comment: this.comment.Comment,
        userName: this.user.lastName + ' ' + this.user.firstName
      });
      this.comment = {
        DBFileID: 0,
        Comment: "",
        CommentID: 0
      };
    });
  }
}

interface ImageFile {
  fileId: number;
  src?: string;
  srcFalse?: string;
  selected: boolean;
  fileTypeID: number;
  updatedOn: any;
}

export interface CommentPhoto {
  DBFileID?: number;
  Comment: string;
  CommentID: number;
}
export interface CommentsPhoto {
  updatedOn?: string;
  comment: string;
  userName: string;
}
